import FieldModel from './FieldModel.js';
import FieldsTableModel from './FieldsTableModel.js';
import FieldOptionsModel from './FieldOptionsModel.js';
import JsonMapDefinitionModel from './json_mapper/JsonMapDefinitionModel.js';
import JsonMapFieldModel from './json_mapper/JsonMapFieldModel.js';
import LookupModel from './lookup/LookupModel.js';
import LookupValueModel from './lookup/LookupValueModel.js';

export default [
	{name:'fields.Field', dataModel: FieldModel},
	{name:'fields.FieldsTable', dataModel: FieldsTableModel},
	{name:'fields.FieldOptions', dataModel: FieldOptionsModel},
	{name:'json_mapper.Definition', dataModel: JsonMapDefinitionModel},
	{name:'json_mapper.Field', dataModel: JsonMapFieldModel},
	{name:'lookup.Lookup', dataModel: LookupModel},
	{name:'lookup.Value', dataModel: LookupValueModel},
]
